<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <!-- <form @submit.prevent="setFilter"> -->
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="row">
          <div class="col">
            <form @submit.prevent="setFilter">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 90px"
                >
                  <a-select-option value="name">
                    Name
                  </a-select-option>
                </a-select>
              </a-input>
            </form>
          </div>
        </div>
        <!-- </form> -->
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Create User Group</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <UserGroupForm
                :viewMode="viewMode"
                :userGroupData="userGroupData"
                :systemModules="systemModules"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{tableProps}">
            <button
              id="view"
              class="btn btn-success btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              id="edit"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
          </template>

          <template #customComponent="{tableProps}">
            <span>{{
              tableProps.rowData.member.first_name +
                ' ' +
                tableProps.rowData.member.last_name
            }}</span>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import UserGroupForm from './UserGroupForm.vue';

import HTTPRequest from '../../controllers/httpRequest';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    UserGroupForm
  },
  data() {
    return {
      gradientType: 'gradient-blue',
      userGroupData: null,
      systemModules: null,
      drawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'User Groups',
        apiUrl: '/api/v1/user_groups',
        fields: ['actions', 'name', 'description', 'code'],
        sortOrder: [
          {
            field: 'id',
            direction: 'asc'
          }
        ],
        filters: {
          name: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  methods: {
    async openDrawer(rowData = null) {
      this.userGroupData = rowData;

      this.viewMode = event.target.id == 'view' ? true : false;
      this.drawer.visible = true;
    },

    async getSystemModules() {
      const response = await HTTPRequest.getRequest('/api/v1/system_modules');
      this.systemModules = response.data;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.userGroupData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    }
  },

  created() {
    this.getSystemModules();
  }
};
</script>

<style scoped></style>
